module.exports = __webpack_public_path__ + "img/icon-download-app@2x.7fb8044a.png";